import React from "react";
import { PortadaNosotros } from "../components/PagesNosotros/PagesNosotros";
import { ClientTestimonials } from "../components/Inicio/Comentarios";
import { NosotrosCard } from "../components/PagesNosotros/Personas";
import { Helmet, HelmetProvider } from "react-helmet-async";


const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
        {
            "@type": "Organization",
            "name": "Hod vending",
            "url": "https://www.hodvending.cl/nosotros",

            "sameAs": [
                "https://www.facebook.com/profile.php?id=61557919715539",
                "https://www.instagram.com/hodvending",
                "https://www.linkedin.com/company/hod-servicios-logísticos/",
                "https://x.com"
            ]
        },
        {
            "@type": "LocalBusiness",
            "name": "HOD Servicios Logísticos ",

            "description": "  En HOD combinamos experiencia, innovación y compromiso con soluciones de vending sustentables y adaptadas a cada cliente. Representamos a Jofemar en Chile.",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "Dirección de su negocio",
                "addressLocality": "Ciudad",
                "addressRegion": "Región",
                "postalCode": "Código Postal",
                "addressCountry": "CL"
            },
            "priceRange": "$$",
            "openingHours": "Mo-Fr 08:00-17:00",
            "url": "https://www.hodvending.cl/nosotros"
        },
        {
            "@type": "WebPage",
            "name": "Productos",
            "url": "https://www.hodvending.cl/nosotros",
            "datePublished": "2024-07-01",
            "description": " En HOD combinamos experiencia, innovación y compromiso con soluciones de vending sustentables y adaptadas a cada cliente. Representamos a Jofemar en Chile.",
            "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://www.hodvending.cl/nosotros"
            }
        }
    ]
};
export const IndexNosotros = () => {
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title> Conoce HOD | Distribuidores Oficiales Jofemar en Chile
                    </title>
                    <meta
                        name="description"
                        content=" En HOD combinamos experiencia, innovación y compromiso con soluciones de vending sustentables y adaptadas a cada cliente. Representamos a Jofemar en Chile.

                 
                        "
                    />
                    <meta
                        name="keywords"
                        content="empresa de vending Chile, historia HOD, vending sostenible, equipo HOD, tecnología vending, Jofemar Chile."
                    />
                    <meta
                        property="og:description"
                        content=" En HOD combinamos experiencia, innovación y compromiso con soluciones de vending sustentables y adaptadas a cada cliente. Representamos a Jofemar en Chile.

                 "
                    />
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content="https://www.hodvending.cl/nosotros" />
                    <meta property="og:title" content=" Conoce HOD | Distribuidores Oficiales Jofemar en Chile
" />
                    <meta property="og:image" content="%PUBLIC_URL%/favicon.ico" />
                    <meta name="author" content="HOD Servicios Logísticos " />
                    <meta name="robots" content="index,follow" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <meta name="publisher" content="HOD Servicios Logísticos " />
                    <link rel="canonical" href="https://www.hodvending.cl/nosotros" />
                    <script type="application/ld+json">
                        {JSON.stringify(schemaData)}
                    </script>
                </Helmet>
            </HelmetProvider>
               <h1 style={{color:'transparent', position:'absolute', width:'80px', fontSize:'1px'}}> cotizar vending, presupuesto máquinas expendedoras, asesoría vending, cotización automática, soluciones vending, catálogo Jofemar Chile, empresa de vending Chile, historia HOD, vending sostenible, equipo HOD, tecnología vending, Jofemar Chile, máquinas vending Chile, soluciones automatizadas, vending para empresas, vending inteligente, distribución automática, Jofemar Chile, máquinas vending Chile, soluciones automatizadas, vending para empresas, vending inteligente, distribución automática, Jofemar Chile, servicio técnico vending, instalación máquinas vending, mantenimiento vending, soporte postventa, asistencia vending, repuestos Jofemar</h1>
            <PortadaNosotros />
            <NosotrosCard />
            <ClientTestimonials />
        </>
    )
}